import SelectComponent from '@components/inputs/select/Select.component';
import TextFieldComponent, { selectCallingCodeItems } from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import PersonIcon from '@mui/icons-material/Person';
import { Divider, Stack, Typography } from '@mui/material';
import { ContactRole, CreateAuditInformation } from '@store/audits/audits-information/audits-information.model';
import { useTranslation } from 'react-i18next';
interface PreAuditProps {
  updateAuditInformation: (
    field: keyof CreateAuditInformation, value: any
  ) => void;
  auditInformation?: CreateAuditInformation;
  errors: any;
}


const PreAuditContact = (props: PreAuditProps) => {

  const { t } = useTranslation();
  const { updateAuditInformation, auditInformation, errors } = props;

  return (
    <>
      <Stack py="24px" pr="10px">
        <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
          <PersonIcon sx={{ backgroundColor: '#61D2CE', color: 'white', width: '25px', borderRadius: '2px' }} />
          <Typography fontSize={24} fontWeight="700">
            {t('audits.preAudit.contact.title')}
          </Typography>
        </Stack >
        <Stack py="24px" pr="10px" spacing={1.5}>
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.contact.lastname')}
            placeholder={t('audits.preAudit.contact.lastname')}
            handleChange={(lastname) => updateAuditInformation('contact', { lastName: lastname })}
            value={auditInformation?.contact?.lastName ?? ''}
          />
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.contact.firstname')}
            placeholder={t('audits.preAudit.contact.firstname')}
            handleChange={(firstname) => updateAuditInformation('contact', { firstName: firstname })}
            value={auditInformation?.contact?.firstName ?? ''}
          />
          <SelectComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.contact.role')}
            placeholder={t('global.select')}
            handleChange={(role) => updateAuditInformation('contact', { role: role })}
            items={ContactRole.selectItems()}
            value={auditInformation?.contact?.role ?? ''}
            error={errors.role}
            required={true}
          />
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.contact.email')}
            placeholder={t('audits.preAudit.contact.email')}
            handleChange={(email) => updateAuditInformation('contact', { email: email })}
            value={auditInformation?.contact?.email ?? ''}
          />
          <Stack direction='row' spacing={1} alignItems={'center'}>
            <SelectComponent
              label={t('audits.preAudit.contact.phone')}
              handleChange={(code) => {
                updateAuditInformation('contact', { codePhone: code });
              }}
              items={selectCallingCodeItems()}
              value={auditInformation?.contact?.codePhone ?? ''}
              labelWidth={Sizes.drawerInputLabelWidth}
              required={true}
            />
            <Stack pt={errors.phoneNumber ? '0.85rem' : undefined}>
              <TextFieldComponent
                color="primary"
                fullWidth
                labelWidth={Sizes.drawerInputLabelWidth}
                placeholder={t('audits.preAudit.contact.phone')}
                handleChange={(phone) => updateAuditInformation('contact', { phoneNumber: phone })}
                value={auditInformation?.contact?.phoneNumber ?? ''}
                error={errors.phoneNumber}
                required={true}
              />
            </Stack>
          </Stack>
          <Divider variant="fullWidth" orientation="horizontal" />
        </Stack>
      </Stack >
    </>
  );
};

export default PreAuditContact;
